/**
 * 결과 본문 문법 (한 줄 단위)
 *
 *   ## 소제목            → 굵은 소제목
 *   ---                  → 점선 구분선
 *   ![설명](이미지키)     → result.images[이미지키] 이미지 (폭 지정: ![설명](이미지키 50%))
 *   (빈 줄)              → 문단 나누기. 빈 줄을 더 넣으면 그만큼 한 줄씩 더 띄웁니다.
 *   그 외                → 본문. 줄바꿈은 그대로 줄바꿈이 됩니다.
 *
 * 줄 안에서
 *   ==형광펜==   **굵게**
 */

const HEADING = /^##\s+(.*)$/;
const DIVIDER = /^-{3,}$/;
const IMAGE = /^!\[([^\]]*)\]\(\s*(\S+)(?:\s+(\d+(?:\.\d+)?%))?\s*\)$/;

export const parseBody = (body = "") => {
  const blocks = [];
  let lines = [];
  let blankRun = 0;

  const flushParagraph = () => {
    if (lines.length) blocks.push({ type: "paragraph", lines });
    lines = [];
  };

  const pushBlock = (block) => {
    flushParagraph();
    // 문단 사이 기본 간격(빈 줄 1개)을 넘는 빈 줄은 추가 여백으로
    if (blankRun > 1 && blocks.length) {
      blocks.push({ type: "space", lines: blankRun - 1 });
    }
    blankRun = 0;
    if (block) blocks.push(block);
  };

  body
    .replace(/\r\n/g, "\n")
    .trim()
    .split("\n")
    .forEach((raw) => {
      const line = raw.trim();
      if (line === "") {
        flushParagraph();
        blankRun += 1;
        return;
      }
      let m;
      if ((m = line.match(HEADING))) return pushBlock({ type: "heading", text: m[1] });
      if (DIVIDER.test(line)) return pushBlock({ type: "divider" });
      if ((m = line.match(IMAGE))) return pushBlock({ type: "image", alt: m[1], key: m[2], width: m[3] });
      if (!lines.length) pushBlock(null);
      lines.push(line);
    });
  flushParagraph();
  return blocks;
};

const INLINE = /(==[^=]+==|\*\*[^*]+\*\*)/g;

/** 한 줄을 [{ text, mark?, bold? }] 조각으로 나눕니다. */
export const parseInline = (line) =>
  line
    .split(INLINE)
    .filter(Boolean)
    .map((part) => {
      if (part.startsWith("==") && part.endsWith("=="))
        return { text: part.slice(2, -2), mark: true };
      if (part.startsWith("**") && part.endsWith("**"))
        return { text: part.slice(2, -2), bold: true };
      return { text: part };
    });
